import { render } from "./CarouselUnitExpansion.vue?vue&type=template&id=243e7b73"
import script from "./CarouselUnitExpansion.vue?vue&type=script&lang=js"
export * from "./CarouselUnitExpansion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselUnitExpansion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "243e7b73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('243e7b73', __exports__)) {
    api.reload('243e7b73', __exports__)
  }
  
  module.hot.accept("./CarouselUnitExpansion.vue?vue&type=template&id=243e7b73", () => {
    api.rerender('243e7b73', render)
  })

}


export default __exports__